export const EXLY_WEBAPP_URL_SEARCH_PARAMS = {
  COMMUNITY_ID: "community", // branded community uuid
};
